module.exports = __webpack_public_path__ + "static/media/play-runaway.8b754c3e.png";